import React from 'react';
import { useState } from 'react';
import './Popup Styles/PopUp.css'
import Radiobtn from './Radiobtn';
import Additional from './Additional';
import Form from './Form';
import Swal from 'sweetalert2';
import { useCart } from "react-use-cart";

const options = [
  { id: 1, name: "Small", price: 10 },//id:1 will be the default one
  { id: 2, name: "Medium", price: 20 },
  { id: 3, name: "Large", price: 30 },
];

const topping = [
  { id: '4', name: "Meat", price: 10, img: "https://img.icons8.com/fluency/48/null/steak.png", quantity: 1 },
  { id: '5', name: "Jerky", price: 20, img: "https://img.icons8.com/fluency/48/null/steak.png", quantity: 1 },
  { id: '6', name: "Cheeze", price: 30, img: "https://img.icons8.com/fluency/48/null/steak.png", quantity: 1 },
];

const PopUp = ({ open, onClose, name, id, price, img, des, displayDes, displayOption, displayAdditional, displaySpecialInstruction }) => {
  const [quantity] = useState(1);
  const defaultOption = options.find(option => option.id === 1);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [checked, setChecked] = useState({});
  const [specialInstructions, setSpecialInstructions] = useState('');
  const { addItem } = useCart();

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleToppingChange = (topping, isChecked) => {
    if (isChecked) {
      setChecked({ ...checked, [topping.id]: topping });
    } else {
      const newChecked = { ...checked };
      delete newChecked[topping.id];
      setChecked(newChecked);
    }
  };

  const handleSpecialInstructionsChange = (value) => {
    setSpecialInstructions(value);
  };
  const handleAddToCart = () => {
    const item = {
      id: id + selectedOption.id + Object.values(checked).map((topping) => topping.id),
      name: name,
      price: selectedOption.price,
      image: img,
      quantity: quantity,
      option: selectedOption,
      toppings: Object.values(checked),
      specialInstructions: specialInstructions,
    };
    addItem(item);
    console.log(item)
    console.log(topping)
    onClose();
    setChecked({});

    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom',
      width:'21em',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'success',
      title: 'Item added successfully'
    })
  };

  return (
    <div>
      {open ?
        (
          <div onClick={onClose} className='overlay'>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className={`modalContainer ${open ? 'opened' : 'closed'}`}
            >
              <div className='modalLeft'>
                <img className='image' src={img} alt='/' />
              </div>
              <div className='modalRight'>

                <div className="close-container" onClick={onClose} >
                  <div className="leftright"></div>
                  <div className="rightleft"></div>
                  <label className="close">close</label>
                </div>

                <div className='content' >
                  <h2 style={{ marginBottom: "10px" }}>{name}</h2>
                  <h3 style={{ marginBottom: "10px" }}>Rs.{price}</h3>
                  <p style={{ display: displayDes }}> {des} </p>
                  <div style={{display: displayOption }} >
                  <h3 style={{ marginTop: "20px"}}>Choose Option:</h3>
                  {options.map((option) => (
                    <Radiobtn
                      key={option.id}
                      id={option.id}
                      name={option.name}
                      price={option.price}
                      checked={selectedOption && selectedOption.id === option.id}
                      onChange={() => handleOptionChange(option)}
                      groupName="Size"
                    />
                  ))}
                  </div>
                  <div style={{display: displayAdditional}}>
                  <h3 style={{ marginTop: "20px" }}>Extra Toppings:</h3>
                  {topping.map((topping) => (
                    <Additional
                      key={topping.id}
                      id={topping.id}
                      name={topping.name}
                      price={topping.price}
                      img={topping.img}
                      isChecked={checked.hasOwnProperty(topping.id)}
                      onChange={(isChecked) => handleToppingChange(topping, isChecked)}
                    />
                  ))}
                  </div>
                    <div style={{display: displaySpecialInstruction}}>
                  <Form onInputChange={handleSpecialInstructionsChange} />
                  </div>
                </div>

                <div className='btnContainer'>


                  <button className='AddCartbtn' onClick={handleAddToCart}  >
                    
                    ADD TO CART
                    
                  </button>

                </div>
              </div>
            </div>
          </div>
        )
        : null}
    </div>
  );
}

PopUp.defaultProps={
displayDes:"none",
displayOption:"none",
displayAdditional:"none",
displaySpecialInstruction:"block",
}

export default PopUp;

